/* eslint-disable react/require-default-props, jsx-a11y/control-has-associated-label, jsx-a11y/anchor-is-valid, react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Share from '../partials/Share';

import styles from '../../styles/modals/share.module.css';

const propTypes = {
    className: PropTypes.string,
};

const ShareModal = ({ className = null }) => {
    const url = window.location.href;
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <Share className={styles.share} url={url} withoutInfo withoutShare visible />
            </div>
        </div>
    );
};

ShareModal.propTypes = propTypes;

export default ShareModal;
